// extracted by mini-css-extract-plugin
export default {"form":"ExpenseForm_form__6kG-a","input":"ExpenseForm_input__FQVxy","submitBtn":"ExpenseForm_submitBtn__g0xFy"};